const mapping: Record<string, string> = {
  id: 'c=>c.Id',
  name: 'c=>c.Name',
  active: 'c=>c.Active',
}

export const mapSortDynamicCounterParams = (key: string) => mapping[key]
